/**
 * @file camelCase Convert str into camel case.
 * @author yuzong(yuzong@tencent.com)
 */

/**
 * Convert str into camel case.
 *
 * eg: 'foo-bar' => 'fooBar'
 *
 * @param str The str which will be convert.
 * @param prefix The connection chars of the original string, '-' by default.
 */
export function camelCase(str) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  return str.replace(new RegExp('[' + prefix + ']' + '(.)', 'gi'), function (all, letter) {
    return letter.toUpperCase();
  });
}